module.exports = __webpack_public_path__ + "img/byron_jones.6205c11e.png";